"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconComment = void 0;

var React = __importStar(require("react"));

exports.IconComment = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "48",
    height: "40",
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M3.76846 0.00205547C1.70755 0.00205547 0 1.73807 0 3.83345V27.2418C0 29.3371 1.7075 31.0732 3.76846 31.0732L6.88961 31.0713V38.4861C6.88775 39.0572 7.20582 39.5791 7.70615 39.8382C8.20836 40.0954 8.80915 40.0425 9.26113 39.704L20.773 31.0711H43.8506C45.9115 31.0711 47.619 29.3351 47.619 27.2397V3.8314C47.619 1.73606 45.9116 0 43.8506 0L3.76846 0.00205547ZM3.76846 3.02782H43.8525C44.3156 3.02782 44.643 3.36066 44.643 3.83156V27.2399C44.643 27.7108 44.3156 28.0436 43.8525 28.0436H20.2782C19.962 28.0474 19.6533 28.1533 19.4003 28.3462L9.86591 35.4947V29.5642C9.86777 29.1595 9.70967 28.7738 9.43066 28.4882C9.1498 28.2026 8.7685 28.0438 8.37228 28.0438H3.76867C3.30552 28.0438 2.97813 27.7109 2.97813 27.24V3.83172C2.97813 3.36084 3.3055 3.02798 3.76867 3.02798L3.76846 3.02782Z",
    fill: color
  }));
});